import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { JhiEventManager } from './event-manager.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineNotificationService {
  private isCurrentlyOffline = false;
  private lastOnlineEvent?: dayjs.Dayjs;

  constructor(private readonly eventManager: JhiEventManager) {}

  public isOffline(): boolean {
    return this.isCurrentlyOffline;
  }

  public setOffline(): void {
    this.setIsOffline(true);
  }

  public setOnline(): void {
    this.lastOnlineEvent = dayjs();
    this.setIsOffline(false);
  }

  // On ne notifie que lors d'un changement d'état
  private setIsOffline(isOffline: boolean): void {
    if (isOffline !== this.isCurrentlyOffline) {
      this.isCurrentlyOffline = isOffline;
      this.eventManager.broadcast({ name: 'onNetworkChange', content: { isOffline, lastOnline: this.lastOnlineEvent } });
    }
  }
}
